"use strict";

export default {
  anzeigestatus_antragstellerorg: "anzeigestatus_antragstellerorg",
};
